// extracted by mini-css-extract-plugin
export default {"wrapper":"NX-z","availablePromoMessagesLabel":"OX-z","promoMessageList":"PX-z","promoMessage":"QX-z","appliedPromoMessage":"RX-z","promoMessageAmount":"SX-z"};